import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import ProteinAtlasContent from "./ProteinAtlasContent";
import { getEnsemblId } from "../../../../state/selectors/Identifiers.selectors";
import HelperText from "../../../../components/atoms/HelperText";

const ProteinAtlas = (props) => {
  const url = "https://www.proteinatlas.org/";
  const { data, ensemblId } = props;

  if (data) {
    const content = <ProteinAtlasContent proteinAtlasData={data} />;
    return (
      <div className="varsome-result-fixed">
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title="Human Protein Atlas"
            version={data?.version}
            url={url}
            helperPopup={
              <HelperText fieldDescriptionKey="Human Protein Atlas" />
            }
            content={content}
            titleDetailsRight={
              ensemblId && (
                <small className="tw-mr-4 tw-float-right">
                  <a href={getVarsoUrl(`${url}${ensemblId}`)} target="_blank">
                    View full records on Protein Atlas
                  </a>
                </small>
              )
            }
          />
        </div>
      </div>
    );
  }
  return null;
};

ProteinAtlas.propTypes = {
  data: PropTypes.shape({
    version: PropTypes.string,
    general_info: PropTypes.shape({
      biological_process: PropTypes.string,
      cancer_type: PropTypes.arrayOf(PropTypes.string),
      disease_involvement: PropTypes.string,
      hpa_evidence: PropTypes.string,
      molecular_function: PropTypes.string,
      normalized_disease: PropTypes.arrayOf(PropTypes.string),
      protein_class: PropTypes.string,
      rna_cancer_distribution: PropTypes.string,
      rna_cancer_specificity: PropTypes.string,
      rna_cancer_specificity_score: PropTypes.string,
      rna_specific_fpkm: PropTypes.string,
      uniprot_id: PropTypes.string,
    }),
    pathology_info: PropTypes.arrayOf(
      PropTypes.shape({
        cancer_name: PropTypes.string,
        high_risk: PropTypes.string,
        low_risk: PropTypes.string,
        medium_risk: PropTypes.string,
        not_detected: PropTypes.string,
        normalized_disease: PropTypes.string,
      })
    ),
    tissue_info: PropTypes.arrayOf(
      PropTypes.shape({
        cell_type: PropTypes.string,
        level: PropTypes.string,
        reliability: PropTypes.string,
        tissue_type: PropTypes.string,
      })
    ),
  }),
  ensemblId: PropTypes.string,
};

ProteinAtlas.defaultProps = {
  data: null,
  ensemblId: null,
};

const mapStateToProps = (state) => {
  return {
    ensemblId: getEnsemblId(state),
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorGuard(ProteinAtlas, "HumanProteinAtlas", "Human Protein Atlas"));
